const initialProps = {
  currentProduct: {},
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "UPDATE_CURRENT_PRODUCT":
      return {
        ...state,
        currentProduct: action.payload,
      };
    default:
      return state;
  }
}
